import {Component, OnInit} from '@angular/core';
import {Photo, PhotoGallerySettings} from '../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  photoGallery: PhotoGallerySettings;
  loadAPI: Promise<any>;

  constructor() {
    this.loadAPI = new Promise((resolve) => {
      this.loadBookmundiScript();
      resolve(true);
    });
  }

  getWidth() {
    return window.innerWidth || document.documentElement.clientWidth ||
      document.body.clientWidth;
  }

  getCarouselHeight() {
    const width = this.getWidth();
    return (width > 768 && width < 992) ? 480 : 425;
  }

  shouldShowArrows() {
    return this.getWidth() < 992;
  }

  getCellsToShow() {
    const width = this.getWidth();
    return (width < 554) ? 1 : (width < 992) ? 2 : 4;
  }

  ngOnInit() {
    this.photoGallery = new PhotoGallerySettings({
      iconColor: 'dark',
      photos:
        [
          new Photo({
            title: 'The Founders',
            description: `Kopa Tours was founded by a brother and sister- David (right), and Sara (middle left)- and their spouses- Kellie (middle right) and Daniel (left).`,
            thumbnailPath: '1920x800/kopa-brick-thumbnail.jpg',
            highresPath: '../../assets/img/1920x800/kopa-brick.jpg',
            altPhotoDescription: 'Kopa Tours'
          }),
          new Photo({
            title: 'Conquering Barranco',
            description: `Kopa Tours founder Sara was all smiles after scaling the 800 foot vertical Barranco Wall.`,
            thumbnailPath: '1920x800/sara-barranco-thumbnail.jpg',
            highresPath: '../../assets/img/1920x800/sara-barranco.jpg',
            altPhotoDescription: 'Kopa Tours founder atop Barranco Wall'
          }),
          new Photo({
            title: 'Roof of Africa',
            description: `The four Kopa Tours founders reached the Roof of Africa atop Mount Kilimanjaro after
              the grueling 7 hour overnight trek from Barafu camp.`,
            thumbnailPath: '1920x800/top-of-kili.jpg',
            highresPath: '../../assets/img/1920x800/top-of-kili.jpg',
            altPhotoDescription: 'Red-and-Yellow Barbet'
          }),
          new Photo({
            title: 'Ngorongoro Crater Rim',
            description: `The Kopa Tours founders stand on the edge of Ngorongoro Crater, a stop on the way to Olduvai Gorge and Serengeti National Park.`,
            thumbnailPath: '1920x800/ngorongoro-us-thumbnail.jpg',
            highresPath: '../../assets/img/1920x800/ngorongoro-us.jpg',
            altPhotoDescription: 'Ngorongoro Crater Rim'
          }),
          new Photo({
            title: 'Last Camp Before Summit',
            description: `Barafu Camp is base for the final night time trek to Uhuru Peak. At roughly 15000 feet,
                            Barafu offers spectacular views of Mount Meru and if you're lucky, a blanket of clouds covering the Earth.`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/barafu-camp.jpg',
            altPhotoDescription: 'View of Mount Kilimanjaro\'s peaks.'
          }),
          new Photo({
            title: 'Uhuru Peak through Clouds',
            description: `Uhuru Peak looms behind the clouds as Kopa Tours founder Daniel celebrates a successful Barranco Wall climb.`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/daniel-barranco.jpg',
            altPhotoDescription: 'Uhuru Peak through the clouds'
          }),
          new Photo({
            title: 'Shira Camp Preparation',
            description: `The second night, spent at Shira Camp, was our coldest, windiest night on Kilimanjaro. At Shira camp,
                         be sure to have your guide tell you about Shira Cave!`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/david-shira.jpg',
            altPhotoDescription: 'Shira Camp Kilimanjaro'
          }),
          new Photo({
            title: 'Happy Above the Clouds',
            description: `Kopa founder David waves to the camera after scaling the Barranco Wall!`,
            thumbnailPath: '1920x800/david-barranco-thumbnail.jpg',
            highresPath: '../../assets/img/1920x800/david-barranco.jpg',
            altPhotoDescription: 'Kopa Founder David'
          }),
          new Photo({
            title: 'Last Card',
            description: `On our last night on Kilimanjaro, our guides taught us how to play "Last Card". Playing an 8 reverses the player order, similarly to a reverse in Uno.`,
            thumbnailPath: '',
            highresPath: '../../assets/svg/kopa-branding/playingcard.svg',
            altPhotoDescription: 'A herd of wildebeest cross a dry, flat landscape.'
          }),
          new Photo({
            title: 'About to set off!',
            description: `Kopa Tours founders Sara and Kellie are excited to start their Kilimanjaro trek at Machame Gate. Be on the lookout for monkeys at this park gate!`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/sara-kellie-gate.jpg',
            altPhotoDescription: 'Machame Gate Lunch area.'
          }),
          new Photo({
            title: 'Campsite Sweet Campsite',
            description: `The days you spend on Kilimanjaro will be a wonderful adventure,
                            look forward to rest at your warm campsite after each exciting day.`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/daniel-sara-tent.jpg',
            altPhotoDescription: 'Campsite on Kilimanjaro.'
          }),
          new Photo({
            title: 'Foggy, Sloped Camp',
            description: `4000 meters up, Karanga camp often rests in the clouds. Just before sunset, the clouds may disappear and reveal a beautiful Uhuru Peak backdrop.`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/david-kellie-karanga.jpg',
            altPhotoDescription: 'Karanga Camp Kilimanjaro'
          }),
          new Photo({
            title: 'First Hard Day\'s Work',
            description: `Kopa Tours Founder Daniel was relieved that Day 1 of the hike was over. The first day through the rainforest is sneakily one of the hardest days of the trek!`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x800/daniel-machame.jpg',
            altPhotoDescription: 'Machame Camp Kilimanjaro.'
          }),
          new Photo({
            title: 'Sunrise on Kilimanjaro\'s Peak',
            description: `Be sure to take in the spectacular sunrise on Summit day.`,
            thumbnailPath: '',
            highresPath: '../../assets/img/1920x1080/kilimanjaro-sunrise.jpg',
            altPhotoDescription: 'Sunrise on Mount Kilimanjaro.'
          })
        ]
    });
  }

  public loadBookmundiScript() {
    let isFound = false;
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("bookmundi.com")) {
        isFound = true;
      }
    }

    if (!isFound) {
      const dynamicScripts = ["https://www.bookmundi.com/review-widget/?c=89500"];
      for (const dynamicScript of dynamicScripts) {
        const node = document.createElement('script');
        node.src = dynamicScript;
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('body')[0].appendChild(node);
      }
    }
  }

  public isMobile() {
    return document.body.clientWidth <= 992;
  }

}
